<script lang="ts" setup>
    import { ref, nextTick } from "vue";
    import { ITimelineObstetric, ITimelineSectionClick, TimelineSection } from "../lib/Models/EMR/TimelineModel";
    import { NoTzDate } from '../lib/DateUtils';

    defineExpose({buildDisplay});
    const emit = defineEmits<{
        (e: "displayBuiltSection", strValue: ITimelineSectionClick): void
    }>(); 

    const obstetricsDisplay = ref<ITimelineObstetric[]>();

    function buildDisplay(obstetricsList: ITimelineObstetric[], date: NoTzDate) {
        obstetricsDisplay.value = obstetricsList.filter(item => item.encounterDate === date);
        nextTick(() => { 
            const element = document.getElementById("obstetricsDisplayHtml");
            if (!element)
                return;
            const timelineSectionClick: ITimelineSectionClick =  {
                id: TimelineSection.Obstetrics,
                date: date,
                html: element.innerHTML
            }
            emit("displayBuiltSection", timelineSectionClick);
        }); 
    }

</script>

<template>
    <div id="obstetricsDisplayHtml">
        <div v-for="item in obstetricsDisplay">
            <span class="header-obstetrics-width">EDD:</span><span>{{item.edd}}</span><br />
            <span class="header-obstetrics-width">Weeks Gest:</span><span>{{item.weeksGest}}</span><br />
            <span class="header-obstetrics-width">Fundal Height:</span><span>{{item.fundalHeight}}</span><br />
            <span class="header-obstetrics-width">Presentation:</span><span>{{item.presentation}}</span><br />
            <span class="header-obstetrics-width">FHR:</span><span>{{item.fhr ?? ""}}</span><br />
            <span class="header-obstetrics-width">Fetal Movement:</span><span>{{item.fetalMovement ?? ""}}</span><br />
            <span class="header-obstetrics-width">Preterm Labor:</span><span>{{item.pretermLabor ?? ""}}</span><br />
            <span class="header-obstetrics-width">BP:</span><span>{{item.systolic ?? ""}}/{{item.diastolic ?? ""}}</span><br />
            <span class="header-obstetrics-width">Weight:</span><span>{{item.weight ?? ""}}</span><br />
            <span class="header-obstetrics-width">Urine Albumin:</span><span>{{item.urineAlbumin ?? ""}}</span><br />
            <span class="header-obstetrics-width">Urine Glucose:</span><span>{{item.urineGlucose ?? ""}}</span><br />
            <span class="header-obstetrics-width">Next Appt:</span><span>{{item.nextAppointment ?? ""}}</span><br />
            <span class="header-obstetrics-width">Comments:</span><span>{{item.comments ?? ""}}</span><br />
            <span>&nbsp;</span><br />
        </div>
    </div>
</template>
